import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  _autoSaveStarted = 0
  _autoSaveSuccesses = 0

  connect() {
    document.addEventListener("super-form:autosave:started", this._onAutoSaveStarted)
    document.addEventListener("super-form:autosave:success", this._onAutoSaveSuccess)
  }

  _onAutoSaveStarted = () => {
    this._autoSaveStarted++
    if (this._autoSaveStarted - this._autoSaveSuccesses > 0) {
      this.element.setAttribute('in-progress', '')
    }
  }

  _onAutoSaveSuccess = () => {
    this._autoSaveSuccesses++
    if (this._autoSaveStarted - this._autoSaveSuccesses === 0) {
      this.element.removeAttribute('in-progress')
    }
  }
}
